module.exports = __webpack_public_path__ + "img/close-white.59a35962.svg";